import PictureListSing from '@/components/PictureList/PictureListSing'
export default {
  components: { PictureListSing },
  data(){

    return{
      companyList:[],
      url:{
        get: SZH.assets.api + '/Custom/GetCompanyListInfo',
        SaveCusMaterielImage: SZH.assets.api + '/Custom/SaveCusMaterielImage',
        RestCustomAuthState: SZH.assets.api + '/Custom/RestCustomAuthState',

      },
      loadingTable:false,
      optionsPro:[],
      limitNum:9,
      picType:'companyQualifications',
      picId:'',
      Pictures:[],
      companyName:'',
      form:{
        CompanyId:'',
        MaterielId:'',
        Pictures:[]
      },
    }
  },
  methods:{
    goBack(){
      this.$router.push({
        path: '/My/myMember'
      })
    },
    ToChange(id){
      let self = this;
      self.$confirm('确定要变更企业信息吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        self.$http.post(self.url.RestCustomAuthState, {
          Data:{
            Id:id,
            CustomType:1,
          }
        }).then(result => {
          if (result.State == 1) {
            self.ToEdit(id);
          } else {

            self.$message.error(result.Message);
          }
        }, () => {
        });
      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消变更'
        });
      });
    },

    getCompanyList(){
      let self = this;
      self.loadingTable = true;
      self.$http.post(self.url.get, {}).then(result => {
        if (result.state == true) {
          self.companyList = result.data;
        } else {
          self.companyList = [];
        }
        self.loadingTable = false;
      }, () => {
        self.loadingTable = false;
      });
    },
    ToConpanyDetail(id){
      let self = this;
      self.$router.push({
        path:'/My/CompanyAuthen',
        query:{
          Id:id
        }
      });
    },
    AddCompany(){
      let self = this;
      self.$router.push({
        path:'/My/CompanyAuthen'
      });
    },
    ToEdit(id){
      let self = this;
      self.$router.push({
        path:'/My/CompanyAuthen',
        query:{
          Id:id
        }
      });
    },
  },
  created(){
  },
  mounted() {
      this.getCompanyList();
  },
  watch: {

  }
}



// WEBPACK FOOTER //
// ./src/views/Me/CompanyList/CompanyList.js